import { ReactNode } from "react";

export const PageContentLeft = ({ children }: { children: ReactNode }) => {
  return <>{children}</>;
};
